enum ErrorMonitorEnum {
  ERROR = 'ERROR',
  ALERT = 'ALERT',
}

export default ErrorMonitorEnum;
